<div class="career-page">
  <!-- Page Header -->
  <section class="page-header">
    <div class="container">
      <h1 class="page-title">Karriere</h1>
      <p class="page-subtitle">Werden Sie Teil unseres erfolgreichen Teams</p>
    </div>
  </section>

  <!-- Career Intro -->
  <section class="career-intro section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <h2 class="section-title text-start">Ihre Zukunft bei uns</h2>
          <p class="lead">Bei Mitra Sanitär erwarten Sie spannende Herausforderungen, ein familiäres Arbeitsklima und beste Entwicklungsmöglichkeiten. Werden Sie Teil eines Teams, das mit Leidenschaft und Expertise die Zukunft der Sanitär- und Heizungstechnik gestaltet.</p>
          <div class="career-highlights">
            <div class="highlight">
              <i class="fas fa-check-circle"></i>
              <span>Erfahrung</span>
            </div>
            <div class="highlight">
              <i class="fas fa-check-circle"></i>
              <span>Innovative Projekte</span>
            </div>
            <div class="highlight">
              <i class="fas fa-check-circle"></i>
              <span>Persönliche Entwicklung</span>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="career-visual">
            <i class="fas fa-users"></i>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Benefits -->
  <section class="benefits-section section">
    <div class="container">
      <h2 class="section-title">Warum bei uns arbeiten?</h2>
      <div class="row g-4">
        <div class="col-lg-4 col-md-6" *ngFor="let benefit of benefits">
          <div class="benefit-card">
            <div class="benefit-icon">
              <i [class]="benefit.icon"></i>
            </div>
            <h4>{{ benefit.title }}</h4>
            <p>{{ benefit.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Job Offers -->
  <section class="jobs-section section">
    <div class="container">
      <h2 class="section-title">Aktuelle Stellenausschreibungen</h2>
      <div class="jobs-grid">
        <div class="job-card" *ngFor="let job of jobOffers">
          <div class="job-header">
            <h3>{{ job.title }}</h3>
            <div class="job-meta">
              <span class="job-type">{{ job.type }}</span>
              <span class="job-start">{{ job.startDate }}</span>
            </div>
          </div>
          
          <div class="job-content">
            <p class="job-description">{{ job.description }}</p>
            
            <div class="job-details">
              <div class="job-requirements">
                <h5>Anforderungen:</h5>
                <ul>
                  <li *ngFor="let requirement of job.requirements">{{ requirement }}</li>
                </ul>
              </div>
              
              <div class="job-benefits">
                <h5>Wir bieten:</h5>
                <ul>
                  <li *ngFor="let benefit of job.benefits">{{ benefit }}</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div class="job-footer">
            <a href="mailto:hey@mitra-sanitaer.de?subject=Bewerbung {{ job.title }}" class="btn btn-cta">
              Jetzt bewerben
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Application Process -->
  <section class="application-process section">
    <div class="container">
      <h2 class="section-title">So bewerben Sie sich</h2>
      <div class="process-steps">
        <div class="step">
          <div class="step-icon">
            <i class="fas fa-file-alt"></i>
          </div>
          <h4>1. Bewerbung senden</h4>
          <p>Senden Sie uns Ihre vollständigen Bewerbungsunterlagen per E-Mail</p>
        </div>
        <div class="step">
          <div class="step-icon">
            <i class="fas fa-comments"></i>
          </div>
          <h4>2. Erstes Gespräch</h4>
          <p>Wir lernen uns in einem persönlichen Gespräch kennen</p>
        </div>
        <div class="step">
          <div class="step-icon">
            <i class="fas fa-handshake"></i>
          </div>
          <h4>3. Ihre Zukunft</h4>
          <p>Bei gegenseitigem Interesse starten wir gemeinsam durch</p>
        </div>
      </div>
      
      <div class="contact-hr text-center">
        <h4>Haben Sie Fragen?</h4>
        <p>Kontaktieren Sie uns gerne für weitere Informationen</p>
        <a href="mailto:hey@mitra-sanitaer.de" class="btn-email-contact">
          <i class="fas fa-envelope"></i>
          hey&#64;mitra-sanitaer.de
        </a>
      </div>
    </div>
  </section>
</div>